module.exports = __webpack_public_path__ + "img/cur13.8061c8aa.png";